<div class="configurable-panel w-100">
  <div class="d-flex justify-content-between align-items-center mb-3">

    <div class="dropdown">
      <div class="fw-bolder text-dark">Profile:&nbsp;
        <button class="btn btn-sm dropdown-toggle btn-outline-purple rounded-1 me-2"
                style="padding: 5px 10px 5px 10px"
                type="button" data-bs-toggle="dropdown" aria-expanded="false">
          {{ channel?.owner }} / {{ channel?.vertical }} / {{ channel?.code }} / {{ selected?.name }}
        </button>
        <ul class="dropdown-menu dropdown-menu-end bg-bg-3">
          <li *ngFor="let profile of profiles!">
            <a class="dropdown-item" (click)="viewProfile(profile)">
              {{ channel?.owner }} / {{ channel?.vertical }} / {{ channel?.code }} / {{ selected?.name }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="btn-config-box">
      <button class="btn btn-sm btn-config rounded-1 me-3 px-2 disabled">
        <i class="bi bi-pencil-square me-1"></i> Pull
      </button>
      <button class="btn btn-sm btn-config rounded-1 px-2 disabled">
        <i class="bi bi-upload me-1"></i> Push
      </button>
    </div>
  </div>
  <admin-channels-view-common-profile [default]="channel!" [profile]="selected!"/>
</div>
